import { createAdapterToConceptType } from "../../conceptType/adapters/conceptType.adapter";
import { ConceptGroup, ConceptGroupEndpoint } from "../domain/ConceptGroup.model";

type Dictionary = {
    [key: string]: string;
};

const conceptGroupsAttributesDiccionary: Dictionary = {
    id: 'GrupoConceptoID',
    name: 'GrupoConcepto',
    typeId: 'TipoConceptoID',
    order :'Orden',
    groupClassificationId: 'ClasificacionGrupoID',
    groupClassification: 'ClasificacionGrupo',
}

export const createAdapterToFieldConceptGroupEndpoint = (key: string): string => {
    return conceptGroupsAttributesDiccionary[key];
}

export const createAdapterToConceptGroupEndpoint = (conceptGroup: ConceptGroup) => {
    const formattedConceptGroup: Partial<ConceptGroupEndpoint> = {
        GrupoConceptoID: conceptGroup.id ?? undefined,
        GrupoConcepto: conceptGroup.name,
        TipoConceptoID: conceptGroup.typeId,
        Orden: conceptGroup.order,
        ClasificacionGrupoID: conceptGroup.groupClassificationId
    };
    return formattedConceptGroup;
}

export const createAdapterToConceptGroup = (conceptEndpoint: ConceptGroupEndpoint) => {
    const formattedConcept: ConceptGroup = {
        id: conceptEndpoint.GrupoConceptoID,
        name: conceptEndpoint.GrupoConcepto,
        typeId: conceptEndpoint.TipoConceptoID,
        type: conceptEndpoint.TipoConcepto,
        order: conceptEndpoint.Orden,
        groupClassificationId: conceptEndpoint.ClasificacionGrupoID,
        groupClassification: conceptEndpoint.ClasificacionGrupo
    };
    return formattedConcept;
}